import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import type { ArticleFAQ as ArticleFAQItem } from '../../data/articles';
interface ArticleFAQProps {
  id: string;
  faqs: ArticleFAQItem[];
}

/**
 * Accordion FAQ with FAQPage structured data, so the answers are eligible for
 * rich results as well as readable on the page.
 */
export function ArticleFAQ({
  id,
  faqs
}: ArticleFAQProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map(faq => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer
      }
    }))
  };
  return <section id={id} aria-labelledby={`${id}-heading`} className="scroll-mt-28" data-id="element-141" data-mp="202s9fkd9mbd1">
      <script type="application/ld+json" dangerouslySetInnerHTML={{
      __html: JSON.stringify(schema)
    }} data-id="element-142" data-mp="12la7h8jv3huh" />
      <h2 id={`${id}-heading`} className="text-2xl sm:text-3xl font-bold text-navy mb-6" data-id="element-143" data-mp="17j3da0h969u8">
        Frequently Asked Questions
      </h2>
      <dl className="divide-y divide-gray-200 border-t border-b border-gray-200" data-id="element-144" data-mp="2qyucvcz44cit">
        {faqs.map((faq, index) => {
        const isOpen = openIndex === index;
        return <div key={faq.question} data-id="element-145" data-mp="2i6akuvdbt66y" data-mpi={index}>
              <dt data-id="element-146" data-mp="2i58wxqb7op7t">
                <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`${id}-answer-${index}`} className="w-full flex items-start justify-between gap-4 py-5 text-left group" data-id="element-147" data-mp="2i3ocitim2mno">
                  <span className="font-semibold text-gray-900 group-hover:text-navy transition-colors duration-150" data-id="element-148" data-mp="1z7es7oh48zv8">
                    {faq.question}
                  </span>
                  <ChevronDownIcon className={`w-5 h-5 flex-shrink-0 mt-0.5 text-gray-400 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-149" data-mp="3tkxl2l07bua7" />
                </button>
              </dt>
              {isOpen && <dd id={`${id}-answer-${index}`} className="pb-5 -mt-1 pr-9 text-gray-700 leading-relaxed" data-id="element-150" data-mp="1hyvr4ghohkil">
                  {faq.answer}
                </dd>}
            </div>;
      })}
      </dl>
    </section>;
}